module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deactivate smooth slider to import slides":"Please deactivate the smooth slider to be able to import slides.","imported modals":"No modals to import. | One modal imported. | {count} modals imported.","imported slides":"No slides to import. | One slide imported. | {count} slides imported.","not a project":"This file seems broken. Import stopped."}}')
  delete Component.options._Ctor
}
